import React from 'react';
import { Link, useLocation } from 'react-router-dom';
const HeaderLink = ({ path, text, children }) => {
    const location = useLocation();
    const searchForward = location.search.includes('MOCK_E2E') ? '?MOCK_E2E' : '';
    return React.createElement(Link, { className: location.pathname === path ? 'active' : '', to: { pathname: path, search: searchForward } },
        text,
        children);
};
export default HeaderLink;
